module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "commentBox",
    staticClass: "m-footer-comment",
    style: (_vm.style),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.comTxt),
      expression: "content.comTxt"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    ref: "textarea",
    staticClass: "fz13 m-footer-comment-textarea",
    attrs: {
      "placeholder": "我来说两句",
      "id": "j-comment-box"
    },
    domProps: {
      "value": (_vm.content.comTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "comTxt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-footer-comment-btngrp"
  }, [_c('button', {
    staticClass: "c-btn-icons",
    on: {
      "click": _vm.uploadImage
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.photo
    }
  })]), _vm._v(" "), (false) ? _c('span', {
    staticClass: "c-btn-icons"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.emotion
    }
  })]) : _vm._e(), _vm._v(" "), (false) ? _c('span', {
    staticClass: "c-btn-icons"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.mention
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    class: ['c-post', 'fz15', {
      active: _vm.content.comTxt.length > 0 && !_vm.imgLoading
    }],
    on: {
      "click": _vm.pub
    }
  }, [_vm._v("发布")])]), _vm._v(" "), (_vm.imgList.length > 0 || _vm.imgLoading) ? _c('div', {
    staticClass: "m-footer-comment-imgs-preview"
  }, [_c('ul', [_vm._l((_vm.imgList), function(item, index) {
    return _c('li', {
      staticClass: "img-wrapper"
    }, [_c('img', {
      attrs: {
        "src": _vm.hosts.showimg + item.src
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "del fz12",
      on: {
        "click": function($event) {
          return _vm.delImg(index)
        }
      }
    }, [_vm._v("x")])])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgList.length < 4),
      expression: "imgList.length < 4"
    }],
    class: ['img-wrapper', 'add', {
      'loading': _vm.imgLoading
    }],
    on: {
      "click": _vm.uploadImage
    }
  })], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-768fe2c5"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/comment.vue
// module id = 211
// module chunks = 1